"use client";
import MosaicModal from "@/components/Modals/MosaicModal/MosaicModal";
import UploadGuideModal from "@/components/Modals/UploadGuideModal/UploadGuideModal";
import { MosaicModalData } from "@/interfaces/context/modals";
import React, { createContext, useState, ReactNode, useContext } from "react";

interface ModalContextType {
  handleMosaic: (photos: MosaicModalData) => void;
  handleUploadGuide: (show: boolean) => void;
}
const defaultContextData: ModalContextType = {
  handleMosaic: () => {},
  handleUploadGuide: () => {},
};

export const ModalContext = createContext<ModalContextType>(defaultContextData);

export const ModalProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [showMosaic, setShowMosaic] = useState<MosaicModalData>({
    show: false,
    photos: [],
    gallery: null,
  });
  const [uploadGuide, setUploadGuide] = useState(false);
  const handleMosaic = (data: MosaicModalData) => {
    setShowMosaic({
      ...data,
    });
  };
  const handleUploadGuide = (show: boolean) => {
    setUploadGuide(show);
  };

  return (
    <ModalContext.Provider value={{ handleMosaic, handleUploadGuide }}>
      {children}
      <MosaicModal
        onHide={() => {
          handleMosaic({ show: false, photos: [], gallery: null });
        }}
        {...showMosaic}
      />
      <UploadGuideModal
        show={uploadGuide}
        onHide={() => {
          handleUploadGuide(false);
        }}
      />
    </ModalContext.Provider>
  );
};

export const useModals = () => {
  const context = useContext(ModalContext);
  if (context === undefined) {
    throw new Error("useModals must be used within a MaterialProvider");
  }
  return context;
};
